import { Checkbox, Input, Modal, Space } from 'antd';
import { useEffect, useMemo, useState } from 'react';

interface RejectDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string[], remark: string) => void;
}

const RejectDialog = ({ isOpen, onClose, onConfirm }: RejectDialogProps) => {
  const [value, setValue] = useState<string[]>([]);
  const [textValue, setTextValue] = useState<string>('');

  useEffect(() => {
    if (!isOpen) {
      setValue([]);
      setTextValue('');
    }
  }, [isOpen]);

  const handleOk = () => {
    const reason: string[] = [];
    let remark = '';
    value.forEach((item) => {
      switch (item) {
        case 'introduction':
          reason.push('简介虚构');
          break;
        case 'resume':
          reason.push('履历虚构');
          break;
        case 'homepage':
          reason.push('个人主页虚构');
          break;
        case 'invalid':
          reason.push('无效信息');
          break;
        case 'other':
          remark = textValue;
          break;
      }
    });
    onConfirm(reason, remark);
  };

  const confirmDisabled = useMemo(() => {
    return value.length === 0 ? textValue === '' : !value;
  }, [value, textValue]);

  return (
    <Modal
      open={isOpen}
      title="不通过原因"
      width={500}
      onCancel={onClose}
      onOk={handleOk}
      okText="确定"
      cancelText="取消"
      okButtonProps={{
        disabled: confirmDisabled,
        danger: true,
      }}
      destroyOnClose
    >
      <Checkbox.Group
        onChange={(value) => {
          setValue(value);
          setTextValue('');
        }}
        value={value}
        style={{ marginBottom: 10 }}
      >
        <Space direction="vertical">
          <Checkbox value="introduction">简介虚构</Checkbox>
          <Checkbox value="resume">履历虚构</Checkbox>
          <Checkbox value="homepage">个人主页虚构</Checkbox>
          <Checkbox value="invalid">无效信息</Checkbox>
          <Checkbox value="other">其它（备注）</Checkbox>
        </Space>
      </Checkbox.Group>

      <Input.TextArea
        placeholder="请输入不通过原因"
        rows={4}
        value={textValue}
        onChange={(e) => setTextValue(e.target.value)}
        disabled={!value.includes('other')}
      />
    </Modal>
  );
};

export default RejectDialog;
